<style lang="scss">
.el-card__body:empty {
    display: none;
}
</style>
<style lang="scss" scoped>
@include component(employee-rules) {
    @include part(header) {
        height: 50px;
        @include flex-center;
        @include part(text) {
            margin-left: 20px;
            width: 25%;
        }
    }
    @include part(text) {
        padding: 20px;
        text-align: center;
    }
    &__rules {
        margin-bottom: 10px;
        &__row {
            @include flex-center;
            margin-bottom: 10px;
            &__item {
                margin-right: 15px;
            }
        }
    }
    &__col {
        width: 100%;
        padding-right: 20px;
        &:last-child {
            width: 50px;
            padding-right: 0;
        }
        .el-select {
            width: 100%;
        }
    }
}

</style>
<template lang="pug">
el-card.employee-rules
    .clearfix(slot='header')
        .employee-rules__header
            el-switch(v-model='active')
            .employee-rules__header__text Sync staff
            el-alert(v-if='isDirty' type="error" center :closable="false") Some existing matches may be discarded when changing rules
        loading(v-if='$apollo.loading')
        template(v-else-if='rules_type == `calendar`')
            .employee-rules__text(v-if='!rules.length')
                el-button(type="primary", @click='add') Create custom rules
            template(v-else='')
                el-form(:inline='true')
                    el-form-item(label='Manage accounts when ')
                        el-select(v-model='ruleMatch', style='width:100px;')
                            el-option(value='all', label='all')
                            el-option(value='any', label='any')
                    el-form-item(label='of the following rules are met:')
                    .employee-rules__rules(v-for='(rule, index) in rules')
                        .employee-rules__rules__row
                            .employee-rules__col
                                el-select(v-model='rule.group', placeholder='Select').employee-rules__rules__row__item
                                    el-option(v-for='item in types', :key='item.value', :label='item.label', :value='item.value')
                            .employee-rules__col
                                el-select(v-model='rule.operator', placeholder='Select').employee-rules__rules__row__item
                                    el-option(v-for='opp in operators', :key='opp', :label="opp.replace('_', ' ')", :value='ldash.camelCase(opp)')
                            .employee-rules__col
                                el-select(v-model='rule.value')
                                    el-option(v-if="rule.group=='role'" v-for='role in roles', :key='role.contract_role', :label='role.contract_role', :value='role.contract_role')
                                    el-option(v-else v-for='group in filteredGroups(rule.group)', :key='group.id', :label='group.name', :value='group.id')
                            .employee-rules__col
                                el-button(type='danger', @click='remove(rule)', icon='fe fe-trash-2 fe-no-margin', plain='')
                    el-button(v-if='calendar_active', icon='fe fe-plus fe-just-off', @click='add', type='primary') Create new rule
</template>

<script>
import _ from "lodash";
import gql from "graphql-tag";

export default {
    props: {
        rules_type: String,
    },
    data() {
        return {
            active: null,
            original: { active: null },
            calendar_active: null,
            rules: [],
            ruleMatch: "all",
            operators: ["is"],
            groups: null,
            types: [
                {
                    value: "department",
                    label: "Department"
                },
                {
                    value: "campus",
                    label: "Campus"
                },
                {
                    value: "role",
                    label: "Role"
                }
            ],
            ldash: _,
            loaded: false,
        };
    },

    computed: {
        isDirty() {
            return this.original.active === true && this.original.active !== this.active;
        }
    },

    watch: {
        active() {
            this.$emit("input", {
                active: this.active
            });
        },
        ruleMatch() {
            this.update();
        },
        rules: {
            deep: true,
            handler() {
                this.update();
            }
        }
    },

    apollo: {
        groups: {
            query: gql`
                query Groups($typeList: [String!]) {
                    Groups(typeList: $typeList) {
                        id
                        name
                        type
                    }
                }
            `,
            variables: {
                typeList: ["department", "campus"],
            },
            update: r => r.Groups
        },
        roles: {
            query: gql`
                query Directory {
                    Directory {
                        WondeUsers {
                            EmploymentDetails {
                                contract_role
                            }
                        }
                    }
                }
            `,
            
            update: r => {
				const data = _.cloneDeep(r.Directory.WondeUsers);
                
                return _(data)
                    .filter((user) => {
                        return user.base_type === "employee" && !_.isEmpty(user.EmploymentDetails.contract_role);
                    })
                    .map((user) => {
                        return user.EmploymentDetails;
                    })
                    .value();
			}
        },
        rules: {
            query: gql`
                {
                    Settings {
                        id
                        employee_active
                        employee_calendar_active
                        employee_calendar_rule_match
                        employee_calendar_rules {
                            group
                            operator
                            value
                        }
                    }
                }
            `,
            update(r) {
                if (this.rules_type == 'calendar') {
                    this.original = _.cloneDeep({
                        active: r.Settings.employee_calendar_active,
                        match: r.Settings.employee_calendar_rule_match,
                        rules: r.Settings.employee_calendar_rules
                    });

                    this.active = _.cloneDeep(r.Settings.employee_calendar_active);
                    this.ruleMatch = _.cloneDeep(r.Settings.employee_calendar_rule_match);
                } else {
                    this.active = _.cloneDeep(r.Settings.employee_active);
                }
                
                return _.cloneDeep(r.Settings.employee_calendar_rules);
            }
        } 
    },
    methods: {
        update() {
            this.$emit("input", {
                active: this.active,
                match: this.ruleMatch,
                rules: _.map(this.rules, r => {
                    return _.pick(r, ["group", "operator", "value"]);
                })
            });
        },
        filteredGroups(type) {
            return _.filter(this.groups, { type });
        },
        add() {
            this.rules.push({ group: null, operator: "is", value: null });
        },
        remove(rule) {
            this.rules = _.filter(this.rules, r => r != rule);
        }
    }
};
</script>

